<template>
    <div id="DpSetDestination">
        <div class="px-3">
            <p class="pa-2 headline">お届け先をご記入ください。</p>
            <v-form ref="destination">
            <v-text-field
                    label="お名前"
                    v-model="customer.name"
                    :rules="[rules.required]"
                    outline
            ></v-text-field>
            <v-text-field
                    label="Email"
                    v-model="customer.email"
                    :rules="[rules.required, rules.email]"
                    outline
                    type="email"
            ></v-text-field>
            <v-text-field
                    label="携帯電話番号"
                    v-model="customer.tel"
                    outline
                    type="tel"
                    :rules="[rules.required,rules.phone]"
            ></v-text-field>
            <p>赤いマーカーを一本指で動かして、正確な受取先(建物の入口)を指定してください。地図は二本指で動きます。</p>
            <p>地図選択後、<strong>スクロールして</strong>、郵便番号と住所を入力してください。</p>
            <v-btn small dark class="mb-2" color="blue" @click="getLocation">GPSで現在位置を測位</v-btn>
            <div id="map" style="height:300px;" class="mb-5"></div>


            <v-text-field
                    label="お届け先郵便番号"
                    v-model="customer.zip"
                    outline
                    maxlength="7"
                    :rules="[rules.required, rules.zipcode]"
                    type="tel"
            ></v-text-field>
            <p>地図上のマーカーを動かすと、住所を自動入力します。<strong>建物名や号室</strong>が入力されていることを確認してください。</p>
            <v-textarea
                    label="お届け先住所"
                    v-model="customer.address"
                    outline
            ></v-textarea>

            <v-checkbox
                    v-model="keepLocalData"
                    label="端末に入力データを保存しない場合はオフにしてください。"
            ></v-checkbox>

            <v-btn color="orange" block
                   @click.prevent="goDateTime"

            >
                宅配料の確認と日時の入力へ
            </v-btn>
            </v-form>

        </div>

        <v-dialog
                v-model="gpsWorking"
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    GPSで現在位置を測位中
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>
import  { Logger } from 'aws-amplify';
const logger = new Logger('DpSetDest','INFO');
import { AmplifyEventBus } from 'aws-amplify-vue'
export default {
    //
    // This page is navigated by beforeEnter at router.js
    //
    data() {
        return {
            map:{},
            marker:{},
            currentLocation:{},
            gpsWorking:false,
            keepLocalData:true,
            directDistance:undefined,
            rules:{
                required: value => !!value || '必ず入力してください。',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'メールアドレスが正しくありません。'
                },
                zipcode: value => {
                    const pattern = /[0-9]{7}/
                    return pattern.test(value) || '7桁の半角数字(ハイフンなし)で入力してください。'
                },
                phone:value => {
                    const pattern = /^[0-9]+$/
                    return pattern.test(value) || '半角数字(ハイフンなし)だけで入力してください。'
                }
            },
        }
    },
    created() {

    },
    beforeDestroy() {
        logger.info("DpSetDest beforeDestroy")


    },
    async mounted() {
        logger.info("DpSetDest")
        AmplifyEventBus.$emit('setBackTo', "/cart")
        // eslint-disable-next-line
        if ('google' in window && typeof google === 'object' && typeof google.maps === 'object'){
            logger.info("google map loaded already.")
        }else{
            await loadGoogleMaps()
        }
        this.showMap()
        if(!this.customer.gps){
            this.getLocation()
        }
        //reset userSelect
        this.userSelect = {}

    },
    methods:{
        getDirectDistance:function(){
            const origin = {
                lat:this.$store.state.location.lat,
                lng:this.$store.state.location.lng
            }
            const dest = {
                lat:this.customer.gps.lat,
                lng:this.customer.gps.lng
            }
            const distanceNaked = haversine_distance(origin,dest)
            logger.info("distance",distanceNaked)
            const directDistance = Math.floor(distanceNaked*1000)/1000
            return directDistance
        },
        getLocation:function(){
            this.gpsWorking = true
            navigator.geolocation.getCurrentPosition(this.gotLocation,this.geoLocationError);

        },
        gotLocation:function(position) {
            logger.info("gotLocation", position)
            this.gpsWorking = false
            const currentLocation = {lat:position.coords.latitude,lng:position.coords.longitude}
            this.map.setCenter(currentLocation)
            this.map.setZoom(19)
            const gps = {lat:position.coords.latitude,lng:position.coords.longitude}
            this.$set(this.customer,"gps",gps)
            // eslint-disable-next-line
            const latLng = new google.maps.LatLng( currentLocation.lat, currentLocation.lng )
            this.marker.setPosition(latLng)
        },
        geoLocationError:function(err){
            logger.info("geoLocationError",err)
            this.gpsWorking = false
            alert("現在地が取得できませんでした。手動で地図を動かしてください。")
        },

        geoCodeByLocation:function(latlng){
            const that = this
            //geocoder
            // eslint-disable-next-line
            const geocoder = new google.maps.Geocoder;
            geocoder.geocode({'location': latlng,region:"jp",language:"ja"}, function(results, status) {
                logger.info("status",status)
                logger.info("results",results)
                that.processLocationResults(results)
            })
        },
        processLocationResults:function(results){
            let addrToPick
            for(let resultIndex in results){
                const result = results[resultIndex]
                if(result.types){
                    for(let typeIndex in result.types){
                        const type = result.types[typeIndex]
                        if(type=="street_address"){
                            addrToPick = result
                            break
                        }
                    }
                }
            }
            if(!addrToPick){
                logger.info("no result")
                return false
            }else{
                logger.info("addrToPick",addrToPick)
            }
            // get postalcode
            for(let addrIndex in addrToPick.address_components){
                const addr = addrToPick.address_components[addrIndex]
                if(addr.types.indexOf("postal_code")>=0){
                    const zipText = addr.long_name
                    const zip = zipText.replace(/[^0-9]/g,'')
                    logger.info("got zip")
                    this.$set(this.customer,"zip",zip)
                    const toRemove = "日本、〒" + zipText + " "
                    const address = addrToPick.formatted_address.replace(toRemove,'')
                    this.$set(this.customer,"address",address)
                    break
                }

            }


        },
        showMap:function() {
            // Google Maps loaded at index.html
            let lat = 26.2157383
            let lng = 127.6788977
            if(this.customer.gps){
                lat = this.customer.gps.lat
                lng = this.customer.gps.lng
            }


            //logger.info("placeId", placeId)
            // eslint-disable-next-line
            this.map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: lat, lng: lng},
                zoom: 19,
                fullscreenControl:false,
            });
            this.setMapMarker()
            this.setMapListner()
        },
        setMapMarker:function(){
            // eslint-disable-next-line
            this.marker = new google.maps.Marker({
                position: this.map.getCenter(),
                map: this.map,
                draggable: true // ドラッグ可能にする
            });
        },
        setMapListner:function(){
            const that = this
            // eslint-disable-next-line
            google.maps.event.addListener(this.marker, 'dragend', function(){
                logger.info("marker lat",that.marker.position.lat());
                logger.info("marker lat",that.marker.position.lng());
                const gps = {lat:that.marker.position.lat(),lng:that.marker.position.lng()}
                that.$set(that.customer,"gps",gps)
                // eslint-disable-next-line
                const latlng = new google.maps.LatLng(that.marker.position.lat(), that.marker.position.lng());
                that.geoCodeByLocation(latlng)
            });
        },
        goDateTime:function(){
            logger.info("next clicked",this.customer)
            if(!this.customer.gps){
                alert("地図上のピンをお届け先に動かしてください。")
                return false
            }
            const distance = this.getDirectDistance()

            if(this.deliveryProvider && this.deliveryProvider.maxDistance
                && distance <= this.deliveryProvider.maxDistance){
                this.$set(this.customer,"distance",distance)
                logger.info("directDistance",distance)
            }else{
                alert("ご指定のお届け先の距離が"+distance+"kmで、遠すぎます。")
                return false
            }


            // validation
            if(this.$refs.destination.validate()){
                const toUserSelect = {}
                for(let i in this.customer){
                    if(i != "keepLocalData"){
                        toUserSelect[i] = this.customer[i]
                    }
                }
                this.userSelect = toUserSelect
                this.$router.push("/dpSetDateTime")

            }else{
                alert("入力内容を確認してください")
            }
            // delete if customer checkbox off
            if(!this.keepLocalData){
                this.customer = {}
            }
        }
    },
    computed: {
        customer: {
            get() {
                return this.$store.state.customer
            },
            set(value) {
                this.$store.commit('setCustomerMT', value)
            }

        },
        userSelect:{
            get() {
                return this.$store.state.userSelect
            },
            set(value) {
                this.$store.commit('setUserSelectMT', value)
            }

        },
        deliveryProvider: {
            get() {
                return this.$store.state.deliveryProvider
            },
            set(value) {
                this.$store.commit("setDeliveryProviderMT", value)
            }
        },
    },
}

function loadGoogleMaps () {
    // eslint-disable-next-line
    return new Promise(function (resolve) {
        var script = document.createElement('script')
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBJRu6BJJrzedXrU3KSjmHlF1BTp_TRP-k&libraries=places&language=ja&region=JP"
        script.onreadystatechange = script.onload = function () {
            var interval = setInterval(function () {
                if (!script.readyState || /loaded|complete/.test(script.readyState)) {
                    clearInterval(interval)
                    console.log('google maps js loaded.')

                    resolve(true)
                }
            }, 100)
        }
        document.getElementsByTagName('head')[0].appendChild(script)
    })
}


function haversine_distance(mk1, mk2) {
    var R = 6371.0710; // Radius of the Earth in km
    var rlat1 = mk1.lat * (Math.PI/180); // Convert degrees to radians
    var rlat2 = mk2.lat * (Math.PI/180); // Convert degrees to radians
    var difflat = rlat2-rlat1; // Radian difference (latitudes)
    var difflon = (mk2.lng-mk1.lng) * (Math.PI/180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
    return d;
}
</script>
<style>
    .theme--light.v-text-field--outline > .v-input__control > .v-input__slot{
        background-color: white !important;
    }
</style>